<template>
  <li v-if="!hasChild">
    <router-link :to="to">
      <fa-icon :icon="icon" v-if="icon" />
      {{ label }}
    </router-link>
  </li>
  <li v-else>
    <a :class="{ 'is-active': showMenu }" @click="showMenu = !showMenu">
      <fa-icon icon="chevron-right" :rotation="showMenu ? 90 : undefined"></fa-icon>
      {{ label }}
    </a>
    <ul v-if="showMenu">
      <slot></slot>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'MenuItem',

  data () {
    return {
      showMenu: false
    }
  },

  props: {
    label: {
      required: true
    },

    icon: {
      required: false
    },

    to: {
      required: false
    }
  },

  computed: {
    hasChild () {
      return this.$slots.default
    }
  }
}
</script>
